var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs",attrs:{"data-cy":"tabs-component"}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"tab-list"},_vm._l((_vm.options),function(item){return _c('div',{key:item.value,staticClass:"tab-item-wrapper"},[_c('div',{class:[
                    'tab-item',
                    {
                        active: _vm.multiple
                            ? _vm.currentValue.includes(item.value)
                            : _vm.currentValue === item.value,
                    } ],on:{"&click":function($event){return _vm.onClick(item.value)}}},[_vm._v(" "+_vm._s(item.label)+" ")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }